module.exports = __webpack_public_path__ + "static/media/Language.42d879b0.png";